import {
    SET_DELETE_CS_MODAL,
    SET_EDIT_CS_MODAL,
    SET_DELETE_CS_DATA,
    SET_EDIT_CS_DATA,
    CUSTOMERS_SIGNUP,
    FETCH_CUSTOMER_ALL,
    ADD_NEW_CUSTOMER,
    SET_CHANGE_STATUS,
    OPEN_MESSAGE_MODAL,
    SAVE_BACKUP_CUSTOMERS
} from './actions';

export default function reducer(
    state = {
        showCSdeleteModal: false,
        showCSeditModal: false,
        fetchCustomer: true,
        addNewCustomer: false,
        showChangeStatus: false,
        isOpenMessageModal: false,
        deleteCSData: null,
        editCSData: null,
        allCustomersData: [],
        backupAllCustomersData: []
    },
    action
) {
    switch (action.type) {
        case SET_DELETE_CS_MODAL:
            return {
                ...state,
                showCSdeleteModal: action.payload.data,
            };
        case SET_EDIT_CS_MODAL:
            return {
                ...state,
                showCSeditModal: action.payload.data,
            };
        case SET_DELETE_CS_DATA:
            return {
                ...state,
                deleteCSData: action.payload.data,
            };
        case SET_EDIT_CS_DATA:
            return {
                ...state,
                editCSData: action.payload.data,
            };
        case SET_CHANGE_STATUS:
            return {
                ...state,
                showChangeStatus: action.payload.data,
            };
        case CUSTOMERS_SIGNUP:
            return {
                ...state,
                allCustomersData: action.payload.data,
            };
        case SAVE_BACKUP_CUSTOMERS:
            return {
                ...state,
                backupAllCustomersData: action.payload.data,
            };
        case FETCH_CUSTOMER_ALL:
            return {
                ...state,
                fetchCustomer: action.payload.data,
            };
        case ADD_NEW_CUSTOMER:
            return {
                ...state,
                addNewCustomer: action.payload.data,
            };
        case OPEN_MESSAGE_MODAL:
            return {
                ...state,
                isOpenMessageModal: action.payload.data,
            };
        default:
            return state;
    }
    // return state;
}
